import * as HTTP from './http';

export const GetOverview = async(token) => {
    let endpoint = `settings/clients`;

    try{
        var result = await HTTP.GET(endpoint, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.GetOverview\n${e}`);
        return undefined;
    }

    return result;
}

export const CreateClient = async(token, name, labelPrint, products) => {
    let endpoint = `settings/clients`;

    var body = {
        name: name,
        label_print: labelPrint,
        products: products
    };

    try{
        var result = await HTTP.POST(endpoint, body, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.CreateClient\n${e}`);
        return undefined;
    }

    return result;
}

export const AddProducts = async(token, name, products) => {
    let endpoint = `settings/products`;

    var body = {
        name: name,
        products: products
    };

    try{
        var result = await HTTP.POST(endpoint, body, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.AddProducts\n${e}`);
        return undefined;
    }

    return result;
}

export const UpdateFgs = async(token, updates) => {
    let endpoint = `settings/fgs`;

    try{
        var result = await HTTP.PUT(endpoint, { updates: updates }, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.UpdateFgs\n${e}`);
        return undefined;
    }

    return result;
}

export const UpdateZpl = async(token, updates) => {
    let endpoint = `settings/zpl`;

    try{
        var result = await HTTP.PUT(endpoint, { updates: updates }, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.UpdateZpl\n${e}`);
        return undefined;
    }

    return result;
}

export const SetLabelPrint = async(token, name, active) => {
    let endpoint = `settings/labelprint`;

    try{
        var result = await HTTP.PUT(endpoint, { name: name, active: active }, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.SetLabelPrint\n${e}`);
        return undefined;
    }

    return result;
}

export const GetZplTemplates = async(token) => {
    let endpoint = `settings/zpl/templates`;

    try{
        var result = await HTTP.GET(endpoint, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.GetZplTemplates\n${e}`);
        return undefined;
    }

    return result;
}

export const GetZplTemplateContent = async(token, name) => {
    let endpoint = `settings/zpl/templates/${encodeURIComponent(name)}`;

    try{
        var result = await HTTP.GET(endpoint, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.GetZplTemplateContent\n${e}`);
        return undefined;
    }

    return result;
}

// ── Renderer ZPL (proxy al zpl_render.py del controller) ──

export const RenderZplPreview = async(token, zpl, data = null) => {
    // Devuelve { blob } con el PNG, o { error } con el mensaje del servidor
    try{
        const body = data === null ? { zpl } : { zpl, data };
        const response = await fetch('/api/settings/zpl/preview', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': token },
            body: JSON.stringify(body)
        });
        if(!response.ok){
            const j = await response.json().catch(() => ({}));
            return { error: j.message || `HTTP ${response.status}` };
        }
        return { blob: await response.blob() };
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.RenderZplPreview\n${e}`);
        return { error: 'Renderer no disponible' };
    }
}

export const ValidateZpl = async(token, zpl) => {
    try{
        var result = await HTTP.POST('settings/zpl/validate', { zpl: zpl }, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.ValidateZpl\n${e}`);
        return undefined;
    }
    return result;
}

export const ImageToZpl = async(token, payload) => {
    try{
        var result = await HTTP.POST('settings/zpl/image', payload, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.ImageToZpl\n${e}`);
        return undefined;
    }
    return result;
}

// ── Contenido de plantillas con versionado ──

export const SaveTemplateContent = async(token, name, content) => {
    try{
        var result = await HTTP.PUT('settings/zpl/templates/content', { name: name, content: content }, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.SaveTemplateContent\n${e}`);
        return undefined;
    }
    return result;
}

export const GetTemplateVersions = async(token, name) => {
    try{
        var result = await HTTP.GET(`settings/zpl/templates/${encodeURIComponent(name)}/versions`, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.GetTemplateVersions\n${e}`);
        return undefined;
    }
    return result;
}

export const GetVersionContent = async(token, file) => {
    try{
        var result = await HTTP.GET(`settings/zpl/versions/${encodeURIComponent(file)}`, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.GetVersionContent\n${e}`);
        return undefined;
    }
    return result;
}

export const RestoreTemplateVersion = async(token, name, versionFile) => {
    try{
        var result = await HTTP.POST('settings/zpl/templates/restore', { name: name, version_file: versionFile }, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.RestoreTemplateVersion\n${e}`);
        return undefined;
    }
    return result;
}

export const UploadZplTemplate = async(token, files, overwrite = false) => {
    let endpoint = `settings/zpl/templates${overwrite ? '?overwrite=1' : ''}`;

    const data = new FormData();
    for(const f of files){
        data.append('files', f);
    }

    try{
        var result = await HTTP.POST_FILE(endpoint, data, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.UploadZplTemplate\n${e}`);
        return undefined;
    }

    return result;
}

// PTS offset (X/Y added to every .pts point before Digital Dental)
export const GetPtsOffset = async(token) => {
    try{
        var result = await HTTP.GET('settings/pts-offset', token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.GetPtsOffset\n${e}`);
        return undefined;
    }
    return result;
}

export const UpdatePtsOffset = async(token, data) => {
    try{
        var result = await HTTP.PATCH('settings/pts-offset', data, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.UpdatePtsOffset\n${e}`);
        return undefined;
    }
    return result;
}

export const GetPtsOffsetSample = async(token) => {
    try{
        var result = await HTTP.GET('settings/pts-offset/sample', token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.GetPtsOffsetSample\n${e}`);
        return undefined;
    }
    return result;
}

export const PtsOffsetHistory = async(token) => {
    try{
        var result = await HTTP.GET('settings/pts-offset/history', token);
    }catch(e){
        console.log(`CONTROLLER ERROR: settings.PtsOffsetHistory\n${e}`);
        return undefined;
    }
    return result;
}
